// extracted by mini-css-extract-plugin
export default {"search_order":"SettingBanner_search_order__LZZ31","left_side":"SettingBanner_left_side__+PNn+"};